import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
// import SVG from "react-inlinesvg";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
// import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
// import { UserNotificationsDropdown } from "../extras/dropdowns/UserNotificationsDropdown";
// import { QuickActionsDropdown } from "../extras/dropdowns/QuickActionsDropdown";
// import { MyCartDropdown } from "../extras/dropdowns/MyCartDropdown";
// import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { Dropdown } from "react-bootstrap";
import {
  fetchCompany,
  fetchDashboard,
  fetchDashboardNoloading,
  fetchToken,
  selectDataCompany,
} from "../../../../app/pages/company/companySlice";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../app/modules/Auth/_redux/authRedux";
import {
  defaultDate,
  getValueStatus,
  paramsMasterAll,
  showErrorDialog,
  showSuccessDialog,
} from "../../../../app/utility";
import { useHistory } from "react-router-dom";
import {
  fetchDataAllCompany,
  selectDataAllCompany,
} from "../../../../app/pages/user/userSlice";
import Select from "react-select";
import { getUserByToken } from "../../../../app/modules/Auth/_redux/authCrud";

export function Topbar() {
  const uiService = useHtmlClassService();
  const history = useHistory();
  const dataCompany = useSelector(selectDataAllCompany);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);
  const defaultCompany = user.active_company_name;

  const [company, setCompany] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      setCompany(user.active_company);
      await dispatch(fetchDataAllCompany({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  const options = user?.user_companies?.map((item) => ({
    label: item.company_name,
    value: item.company_id,
  }));

  const handleChangeCompany = async (e) => {
    if (e === null) {
      e = undefined;
      setCompany("");
    } else {
      setCompany(e.value);

      const params = {
        active_company: e.value,
      };
      try {
        const response = await dispatch(fetchToken(params));
        if (response.payload.data.status_code === 200) {
          await window.location.reload();

          // await history.push("/dashboard");
          // // await getUserByToken()
          // await dispatch(
          //   fetchDashboardNoloading({
          //     start_date: defaultDate,
          //     end_date: defaultDate,
          //   })
          // );
          await showSuccessDialog(response.payload.data.message);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-item-select mr-4">
        <Select
          menuPortalTarget={document.body}
          styles={{
            control: (base) => ({
              ...base,
              width: 230, // set the width to 230px
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          options={options}
          value={getValueStatus(company, options)}
          placeholder="Select ..."
          onChange={handleChangeCompany}
        />

        {/* <Dropdown onSelect={handleSelect}>
          <Dropdown.Toggle
            variant="secondary"
            id="dropdown-basic"
            style={{ minWidth: "200px" }}
          >
            {defaultCompany}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {options.map((item) => {
              return (
                <Dropdown.Item eventKey={item.value}>
                  {item.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown> */}
      </div>

      {/* {layoutProps.viewSearchDisplay && <SearchDropdown />}

      {layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown />}

      {layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />}

      {layoutProps.viewCartDisplay && <MyCartDropdown />}

      {layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )}

      {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />} */}

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
